//@flow
import React from 'react';
import AuthMechanism, { AuthRealm } from '../auth/AuthMechanism';
import Store from '../store/Store';
import Authenticator2 from '../auth/Authenticator2';
import type { AuthType } from '../auth/AuthType';
import OAuthNotLoggedInBlock from '../login/OAuthNotLoggedInBlock';
import Authenticator from '../protocol/Authenticator';
import NotLoggedBlock from './NotLoggedBlock';
import ViewUtil from '../ViewUtil';

type Props = {};

type State = {
  authMechanism: AuthMechanism
};

export default class LoginScreenHandler extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { authMechanism: null };
    this.authFailureCallback = this.setAuthMechanism.bind(this);
  }

  componentDidMount() {
    Authenticator.getInstance().setOnAuthFailureCallback(this.authFailureCallback);
    this.setAuthMechanism();
  }

  componentWillUnmount() {
    Authenticator.getInstance().removeOnAuthFailureCallback(this.authFailureCallback);
  }

  setAuthMechanism() {
    const externalUserAuthRealm = Authenticator2.getAuthRealmForExternalUserFromWindowsArgument();
    if (externalUserAuthRealm) {
      this.onAuthMechanismChange(externalUserAuthRealm.authMechanism);
    } else {
      const authMechanism = this.state.authMechanism;
      if (Authenticator2.isAuthTypeForAuthMechanism(AuthMechanism.OAuth)) {
        if (authMechanism !== AuthMechanism.OAuth) {
          if(authMechanism){
            this.onAuthMechanismChange(authMechanism);
          }else{
            this.onAuthMechanismChange(AuthMechanism.OAuth);
          }
        }
      } else if (authMechanism === null || !Authenticator2.isAuthTypeForAuthMechanism(authMechanism)) {
        const authTypes: Array<AuthType> = Authenticator2.getAuthTypes();
        if (authTypes && authTypes.length > 0) {
          const authType = authTypes[0];
          if (authType) {
            this.onAuthMechanismChange(authType.getAuthRealm().authMechanism);
          }
        }
      }
    }
  }

  /**
   * @private
   * @memberof LoginScreenHandler
   */
  onAuthMechanismChange = (authMechanism: AuthMechanism): void => {
    this.setState({ authMechanism: authMechanism });
  };

  render() {
    // If this is the link click and the window.entryScreen variable value is set to "CREATE_ACCOUNT" string constant.
    // That means user has to create an account first. In that case, we won't show the  OAuth page.             
    if (window.entryScreen != NotLoggedBlock.LOGIN_SCREEN_STATE_CREATE_ACCOUNT) {
      if (this.state.authMechanism === AuthMechanism.OAuth) {
        return <OAuthNotLoggedInBlock onAuthMechanismChange={this.onAuthMechanismChange} />;
      }
    }
    return <NotLoggedBlock onAuthMechanismChange={this.onAuthMechanismChange} />;
  }
}
